import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Dentist icon
 *
 * @category Medical
 */
const Dentist = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M25.444 6.692c-1.64-2.11-4.95-2-7.27-1.01-2.07.83-4.31.15-6.33-.53-5.12-1.16-7.58 2.55-6.9 7.78.57 4.63 1.99 11.1 5.71 13.86.86.39 1.87 0 2.45-.7 1.09-1.13.83-3.67 2.43-4.44 1.43-.21 1.76 1.9 2.22 2.96.45 1.27 1.74 2.84 3.17 2.36 2.45-1.72 3.9-7.27 4.92-10.47.95-2.98 1.63-7.39-.32-9.68l-.11-.13zm-.13 7.97c-.62 1.98-3.8 14.34-6.1 10.74-1.01-1.58-.82-4.82-3.26-5.15-2.25-.05-2.78 3-3.18 4.64-2.34 4.7-6.49-7-6.79-11.85-.6-4.4.97-8.15 5.93-6.8 2.18.93 4.27 2.71 6.66 2.82.35.02 1.2 0 1.11-.47-.32-.56-1.85-.58-2.44-.84-1.26-.47.71-.68 1.25-.98 5.88-2.85 8.52 2.39 6.87 7.68l-.06.22z"
        />
      </svg>
    );
  }
);

Dentist.displayName = 'Dentist';

export { Dentist };
